import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToggleComponent } from './toggle/toggle.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-cookies-type',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ToggleComponent,
        TranslateModule
    ],
    templateUrl: './cookie-type.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieTypeComponent {
  public readonly type = input.required<string>();
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
  public readonly control = input.required<FormControl>();

}
